
import Vue from "vue";
import { UserInfo } from "../../models/dossier/user-info";
import { DossierService } from "../../services/dossier-service";
import { ViewService } from "../../services/view-service";
import { View } from "@/models/view";
import AppUsersSelectViews from "./UsersSelectViews.vue";
import { TranslateResult } from "vue-i18n";
import { Dossier } from "@/models/dossier/dossier";
import { AuthService } from "@/services/auth-service";
import { CompanyService } from "@/services";

enum Step {
	SELECT_SOURCE_DOSSIER = 0,
	SELECT_SOURCE_USER = 1,
	SELECT_TARGET_USER = 2,
	SELECT_VIEWS = 3
}

export default Vue.extend({
	data(){
		return {
			step: Step.SELECT_SOURCE_DOSSIER,
			sourceUser: null as null | UserInfo,
			sourceDossier: null as any as Dossier,
			targetUsers: [] as UserInfo[],
			users: [] as UserInfo[],
			selectedViews: [] as View[],
			overwriteExistingViews: false,
			dossiers: [] as Dossier[]
		};
	},
	props: {
		value: Boolean,
		userId: Number
	},
	computed: {
		targetDossierId():number{
			return AuthService.wfDossier.id;
		},
		availableTargetUsers():UserInfo[]{
			let allUsers = [...this.users];
			if (this.targetDossierId == this.sourceDossier.id){
				let i = allUsers.findIndex(u=>u.ID == this.sourceUserId);
				if (i == -1) return [];
				allUsers.splice(i,1);
			}
			return allUsers;
		},
		sourceUserId():number {
			if (!this.sourceUser) {
				return 0;
			}
			return this.sourceUser.ID;
		},
		selectSourceDossierVisible():boolean {
			return this.step == Step.SELECT_SOURCE_DOSSIER;
		},
		selectSourceVisible():boolean {
			return this.step == Step.SELECT_SOURCE_USER;
		},
		selectTargetsVisible():boolean {
			return this.step == Step.SELECT_TARGET_USER;
		},
		selectViewsVisible():boolean {
			return this.step == Step.SELECT_VIEWS;
		},
		nextButtonText():TranslateResult {
			if (this.step == this.steps[this.steps.length-1]) {
				return this.$ct("common.confirm");
			}
			return this.$ct("common.next");
		},
		previousButtonText():TranslateResult{
			if (this.step == this.steps[0]) {
				return this.$ct("common.cancel");
			}
			return this.$ct("common.back");
		},
		nextButtonDidsabled():boolean {
			if (this.step == Step.SELECT_SOURCE_USER) {
				return this.sourceUser == null;
			}
			if (this.step == Step.SELECT_TARGET_USER) {
				return this.targetUsers.length == 0;
			}
			return false;
		},
		nextButtonIcon():string {
			if (this.step == this.steps[this.steps.length-1]) {
				return "check";
			}
			return "arrow-right";
		},
		previousButtonIcon():string {
			if (this.step == this.steps[0]) {
				return "ban";
			}
			return "arrow-left";
		},
		steps():Step[]{
			let result = [
				Step.SELECT_SOURCE_USER,
				Step.SELECT_TARGET_USER,
				Step.SELECT_VIEWS,
			];
			if (this.userId == 0){
				result.unshift(Step.SELECT_SOURCE_DOSSIER);
			}
			return result;
		},
		instruction():TranslateResult {
			if (this.step == Step.SELECT_SOURCE_DOSSIER) {
				return this.$ct("select-dossier-to-copy-views-from");
			}
			if (this.step == Step.SELECT_SOURCE_USER) {
				return this.$ct("select-user-of-which-to-copy-views-from");
			}
			if (this.step == Step.SELECT_TARGET_USER) {
				return this.$ct("select-users-to-which-to-copy-views-to");
			}
			return this.$ct("select-views-to-copy");
		}
	},
	methods: {
		async nextClicked(){
			if (this.step == this.steps[this.steps.length-1]) {
				await this.importViews();
				return;
			}
			this.step = this.steps[this.steps.indexOf(this.step)+1];
		},
		previousClicked(){
			if (this.step == this.steps[0]) {
				this.$emit("close");
				return;
			}
			this.step = this.steps[this.steps.indexOf(this.step)-1];
		},
		async selectSourceUser(user:UserInfo){
			this.selectedViews = [];
			this.targetUsers = [];
			this.sourceUser = user;
		},
		async doOverwriteExistingViews(user:UserInfo){
			if (!this.overwriteExistingViews) return;
			let views = await ViewService.getUsersViews(user.ID);
			let result:View[] = [];
			for (let view of this.selectedViews){
				let foundViews = views.filter(v=>v.BrowseID == view.BrowseID && v.Name.trim().toLowerCase() == view.Name.trim().toLowerCase());
				if (foundViews.length == 0)continue;
				result.push(...foundViews);
			}
			if (result.length > 0){
				await ViewService.deleteViews(result, true);
			}
		},
		async importViews(){
			for (let user of this.targetUsers) {
				await this.doOverwriteExistingViews(user);
				for (let v of this.selectedViews){
					v.UserID = user.ID;
				}
				await ViewService.createViews(this.selectedViews);
				this.$emit("close");
			};
		},
		targetUserSelected(user:UserInfo):boolean {
			return this.targetUsers.findIndex(u=>u.ID == user.ID) != -1;
		},
		selectTargetUser(user:UserInfo){
			let index = this.targetUsers.findIndex(u=>u.ID == user.ID);
			if (index == -1) {
				this.targetUsers.push(user);
				return;
			}
			this.targetUsers.splice(index, 1);
		},
		async selectSourceDossier(dossier:Dossier){
			this.sourceDossier = dossier;
		}
	},
	async created(){
		this.dossiers = await DossierService.getDossiers();
		let users = await CompanyService.getUsers();
		this.users = users.filter(u=>u.ID != this.userId);
		let dossier = this.dossiers.find(d=>d.id == AuthService.wfDossier.id);
		if (dossier){
			await this.selectSourceDossier(dossier);
		}else{
			this.selectSourceDossier(this.dossiers[0]);
		}
		if (this.dossiers.length <= 1 || this.userId != undefined) {
			this.nextClicked();
		}
	},
	components: {
		AppUsersSelectViews
	},
	i18nEx: {
		componentPrefix: "components.settings-default"
	}
});
